module.exports = __webpack_public_path__ + "img/other.2466afbd.png";